import React, { useContext, useEffect, useState } from "react";
import styles from "./about.module.css";
import Facilities from "../../hotel_facilities_section";
import SectionTitle from "components/section_title/section_title";
import { useTranslation } from "react-i18next";
import PopularFacilities from "components/popular_facilities/popular_facilties";
import Carousel from "react-bootstrap/Carousel";
// import PhotosGallery from "../../room_details_modal";
import GoogleMapReact from "google-map-react";
import Marker from "components/properties_search_map/marker";
import { Modal, Nav } from "react-bootstrap";
import Placeholder from "components/placeholder";
import { CloseCircleOutlined, FrownOutlined } from "@ant-design/icons";
import RoomGrid from "../rooms/room_grid/room_grid";
import { BookingActionsContext, BookingDataContext } from "containers/data_context";

const BOOTSTRAP_URL_KEYS = { key: process.env.REACT_APP_GOOGLE_MAP_KEY };
const DEFAULT_ZOOM = 15;
const DEFAULT_CENTER = { lat: 51.496644, lng: -0.147614 };

export default function About({ property = {}, showModal, setShowModal }) {
  const isPhotosPresent = Boolean(property?.photos?.length);
  const { t } = useTranslation();

  const hotelPolicy = property?.hotelPolicy;
  const bookingData = useContext(BookingDataContext);
  const { channelId, params } = bookingData;
  const { loadFilterRoomsInfo } = useContext(BookingActionsContext);

  useEffect(() => {
    loadFilterRoomsInfo(channelId, params);
  }, [channelId, params, loadFilterRoomsInfo]);

  const { filterRoomsInfo } = useContext(BookingDataContext);
  const { data: roomsData } = filterRoomsInfo;

  const hotelInfo = hotelPolicy || {};
  const { petsPolicy } = hotelInfo;
  const [activeTab, setActiveTab] = useState("property");

  const allPhotos =
    property?.photos?.length > 0
      ? property?.photos
      : [
          // {
          //   url: "https://fastly.picsum.photos/id/1/200/300.jpg?hmac=jH5bDkLr6Tgy3oAg5khKCHeunZMHq0ehBZr6vGifPLY",
          // },
          // {
          //   url: "https://fastly.picsum.photos/id/6/5000/3333.jpg?hmac=pq9FRpg2xkAQ7J9JTrBtyFcp9-qvlu8ycAi7bUHlL7I",
          // },
          // {
          //   url: "https://fastly.picsum.photos/id/20/3670/2462.jpg?hmac=CmQ0ln-k5ZqkdtLvVO23LjVAEabZQx2wOaT4pyeG10I",
          // },
        ];

  const isPetAllowed = petsPolicy !== "not_allowed" && petsPolicy;
  const chunkArray = (array, size) =>
    array?.reduce((acc, _, i) => (i % size === 0 ? [...acc, array.slice(i, i + size)] : acc), []);

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header color="white">
        <div>{t("hotel_page:hotel_info")}</div>
        <CloseCircleOutlined
          style={{ fontSize: 20, cursor: "pointer" }}
          onClick={() => setShowModal(false)}
        />
      </Modal.Header>
      <Modal.Body style={{ height: "85vh", overflow: "scroll" }}>
        <Nav variant="tabs" activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
          <Nav.Item>
            <Nav.Link eventKey="property">{t("hotel_page:hotel_details")}</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="hotel_gallery">{t("hotel_page:hotel_gallery")}</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="hotel_rooms">{t("hotel_page:hotel_rooms")}</Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="map">{t("global:map")}</Nav.Link>
          </Nav.Item>
        </Nav>
        {activeTab === "property" && (
          <div className="my-4">
            <h6 className={styles.modalHeader}>{property?.title}</h6>
            <div className="my-2">
              <span className={styles.label}>{t("hotel_page:address")}</span>
              <div>{property?.address}</div>
            </div>
            <div className="d-flex flex-wrap my-2">
              <div className="d-flex  mr-4">
                <span className={styles.label}>{t("global:phone")}: </span>{" "}
                <span>{property?.phone}</span>
              </div>
              <div className="d-flex  ">
                <span className={styles.label}>{t("global:email")}: </span>{" "}
                <span>{property?.email}</span>
              </div>
            </div>
            <div className="my-2">
              <span className={styles.label}>{t("hotel_page:check_in_time")}</span>
              <div>
                {hotelPolicy?.checkinFromTime} - {hotelPolicy?.checkinToTime}
              </div>
            </div>
            <div className="my-2">
              <span className={styles.label}>{t("hotel_page:check_out_time")}</span>
              <div>
                {hotelPolicy?.checkoutFromTime} - {hotelPolicy?.checkoutToTime}
              </div>
            </div>
            <div className="my-2">
              <span className={styles.label}> {t("hotel_page:hotel_information")}</span>
              <div>{property.description}</div>
            </div>
            <div className="d-flex flex-wrap my-2">
              <div className="col-md-3">
                <SectionTitle style={{ fontWeight: 500, fontSize: 16, margin: 0 }}>
                  {t("hotel_page:hotel_facilities")}
                </SectionTitle>
                <PopularFacilities property={property} />
                <div className={styles.facilityCard}>
                  <img src=".././pet-care.png" alt="parking" className={styles.iconImage} />
                  {isPetAllowed ? "Pets are Allowed" : "Pets are not Allowed"}
                </div>
              </div>

              {property?.facilities?.map((facGr, index) => (
                <div className="col-md-3" key={index}>
                  <h4 style={{ fontWeight: 500, fontSize: 16, margin: 0 }}>
                    {t(`facility_categories:${facGr?.categoryCode}`)}
                  </h4>
                  {chunkArray(facGr?.facilities, 5)?.map((chunk, colIndex) => (
                    <div key={colIndex}>
                      {chunk.map((fac, facIndex) => (
                        <div className={styles.facilityCard} key={facIndex}>
                          {t(`facilities:${fac?.toLowerCase()}`)}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
        {activeTab === "hotel_gallery" &&
          (isPhotosPresent ? (
            <Carousel
              // activeIndex={activeIndex}
              // controls={false}
              pause="hover"
              wrap={true}
              interval={1000}
              defaultActiveIndex={0}
              fade
            >
              {allPhotos?.map((photo) => (
                <Carousel.Item key={photo?.url}>
                  <img className={styles.mainImage} src={photo?.url} alt={"carosuel-item"} />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <p className="text-center mt-5">No Photos Available</p>
          ))}
        {activeTab === "hotel_rooms" &&
          (!Array.isArray(roomsData) ? (
            <></>
          ) : (
            <div className="row g-3">
              {roomsData.length ? (
                roomsData.map((room, rowIndex) => (
                  <RoomGrid key={rowIndex} room={room} property={property}></RoomGrid>
                ))
              ) : (
                <Placeholder
                  icon={<FrownOutlined />}
                  text={t("rates_table:no_available_rates_placeholder")}
                />
              )}
            </div>
          ))}
        {activeTab === "map" && (
          <div style={{ height: 400, width: "100%" }}>
            <GoogleMapReact
              bootstrapURLKeys={BOOTSTRAP_URL_KEYS}
              center={{
                lat: parseFloat(property?.location?.latitude),
                lng: parseFloat(property?.location?.longitude),
              }}
              zoom={DEFAULT_ZOOM}
              yesIWantToUseGoogleMapApiInternals
            >
              <p
                text={property?.address}
                isHighlighted={false}
                lat={Number(property?.location?.latitude)}
                lng={Number(property?.location?.longitude)}
                className={styles.marker}
              >
                {property?.title}
              </p>
            </GoogleMapReact>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
